var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,2.4c0-0.3-0.2-0.5-0.2-0.5s0.1-0.3,0-0.5C3.2,1.5,3,1.6,2.9,1.7c0,0-0.2-0.1-0.4-0.1S2,1.7,2,1.7 C1.9,1.6,1.7,1.5,1.6,1.5c-0.1,0.1,0,0.5,0,0.5S1.4,2.1,1.4,2.4c0,0.8,0.8,0.8,0.8,0.8S2.1,3.3,2,3.4c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.3-0.2-0.3-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.1,0.1s0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.4,0.5,0.4c0,0,0.1,0,0.2,0 c0,0.1,0,0.2,0,0.2C2,3.9,2,4,2,4C2,4,2,4,2,4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1 c0-0.2-0.1-0.3-0.1-0.3S3.5,3.2,3.5,2.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.1a969fc27042ca4617ff1104855378f8.svg";
export { ForwardRef as ReactComponent };